export function getWidgetPickerStyle() {
    return {
        inner: {
            height: "408px",
        },
        root: {
            marginBottom: "40px",
        },
    };
}
